import { z } from '@harvestiq/zod';
import { safeDbEntitySchema } from './db-entity';

export const deleteEntityResponseSchema = safeDbEntitySchema;

export type DeleteEntityResponse = z.infer<typeof deleteEntityResponseSchema>;
